import Vue from 'vue'
import Vuex from 'vuex'
import { Message } from './Modules/Message'
import { Table } from './Modules/Table'
import events from './Modules/Events/Events'
import axios from 'axios'
import adminDashboard from './Modules/AdminDashboard/AdminDashboard'
import makeupRequests from './Modules/MakeupRequests/MakeupRequests'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
      msalApp: null,
      activeAccount: null,
      logindata: null,
      isAdmin: false,
      // True only once login has fully completed (session cookie set, axios
      // prepared). App.vue holds every page behind this flag.
      authReady: false,
      axios: null,
      api:null,
      currentAdmin: null,
      accounts: null,
      isLoadingTwilio: false,
      loadedAdminDashboard: false,
      expandedSidebar: false,
      announcements: [],
      tabType: null,
      


  },
  mutations: {
    updateAnnouncement(state, { index, updatedAnnouncement }) {
      
      if (index !== -1) {
        Vue.set(state.announcements, index, updatedAnnouncement);
      }
    },

    setTabType(state, payload) {
      state.tabType = payload;
    },
    setAnnouncements(state, payload) {
      state.announcements = payload;
    },
    
    sidebarMutation(state){
      state.expandedSidebar = !state.expandedSidebar
    },
    modifyApi(state) {
        state.api.defaults.headers.Authorization = `${JSON.stringify(state.msalApp.getActiveAccount().idTokenClaims)}`
    },
    accounts(state, payload) {
      state.accounts = payload;
    },
    isAdmin(state, payload) {
      state.isAdmin = payload;
    },
    authReady(state, payload) {
      state.authReady = payload;
    },
    msalApp(state, payload) {
       state.msalApp = payload;
    },
    activeAccount(state, payload) {
      state.activeAccount = payload;
    },
    currentAdmin(state, payload) {
      state.currentAdmin = payload;
    },
    logindata(state, payload) {
        state.logindata = payload;
    },
    axios(state, payload) {
        state.axios = payload;
    },
    api(state, payload){
      state.api = payload;
    },
    setIsLoadingTwilio(state, isLoading){
      state.isLoadingTwilio = isLoading;
    },
    setLoadedAdminDashboard(state, loaded){
      state.loadedAdminDashboard = loaded
    }
  },
  actions: {
    async getEveryGroup(){
      try {
        // console.log('getEveryGroup index')
        const { data } = await axios.get('/api/every_group');
        return data;
        
      } catch (error) {
        console.error(error);
        return null;
      }

    },
  },
  modules: {
    Message,
    Table,
    events,
    adminDashboard,
    makeupRequests,
  }
})
